import { Injectable } from '@angular/core';
import { ApiService } from '../../../../_core/_services/api.service';
import { Subject, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortalManagementPackagesService {
  constructor(private api: ApiService) {}

  packages: any[] = [];
  packages$: Subject<any[]> = new Subject<any[]>();
  packagesQuery$: any;

  getPortalPackagesManagement() {
    return this.api.getAPI('portal/management/products').pipe(
      map((res: any) => {
        return res.body.data;
      })
    );
  }

  // Paged list for the Products table: { count, data } with each product's
  // customer counts. getPortalPackagesManagement() above stays as-is for the
  // product pickers elsewhere.
  listPortalPackagesManagement(queryParams: any) {
    return this.api.getAPI('portal/management/products', queryParams).pipe(map((res: any) => res.body));
  }

  createPortalPackageManagement(formSubmission: any) {
    return this.api.postAPI('portal/management/products', formSubmission);
  }
  updatePortalPackageManagement(id: any, $event: any) {
    // return this.api.putAPI(`portal/management/products/${id}`, $event);
    return this.api.putAPI(`portal/management/products/`, id, $event);
  }

  deletePortalPackageManagement(id: any) {
    return this.api.deleteAPI(`portal/management/products/`, id);
  }

  getProductTags() {
    return this.api.getAPI('portal/management/product-tags').pipe(
      map((res: any) => {
        return res.body.data;
      })
    );
  }

  createProductTag(tag: { name: string; label?: string; description?: string }) {
    return this.api.postAPI('portal/management/product-tags', tag);
  }

  updateProductTag(id: any, tag: { name: string; label?: string; description?: string }) {
    return this.api.putAPI('portal/management/product-tags', id, tag);
  }

  deleteProductTag(id: any) {
    return this.api.deleteAPI('portal/management/product-tags', id);
  }

  setProductTags(productId: any, tagIds: number[]) {
    return this.api.putAtPathAPI(`portal/management/products/${productId}/tags`, tagIds);
  }

  getProductsById(id: any) {
    return this.api.getAPI(`portal/management/products/${id}`).pipe(
      map((res: any) => {
        return res.body;
      })
    );
  }
}
